module.exports = __webpack_public_path__ + "img/webPage.8e2ca2b6.svg";